export default __webpack_public_path__ + "static/python-algorithm-and-data-structure-41d48600177bf78395f73c6ff5c623e6.webp";